export default "__VITE_ASSET__C7OrVeo1__"